export default "__VITE_ASSET__Dnr8TXLG__"